import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getUser: () => api.get('/auth/user'),
  updateUser: (data) => api.put('/auth/user', data),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const userAPI = {
  update: (data) => api.put('/auth/user', data),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const projectAPI = {
  list: () => api.get('/projects'),
  create: (data) => api.post('/projects', data),
  get: (id) => api.get(`/projects/${id}`),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
  getDocuments: (projectId) => api.get(`/projects/${projectId}/documents`),
};

export const agentAPI = {
  chat: (data) => api.post('/agent/chat', data),
  chatStream: (data, onChunk, onDone, onError) => {
    const token = localStorage.getItem('access_token');
    const url = `${API_BASE_URL}/agent/chat/stream`;
    
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    }).then(response => {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      
      function read() {
        return reader.read().then(({ done, value }) => {
          if (done) {
            return;
          }
          
          const chunk = decoder.decode(value, { stream: true });
          const lines = chunk.split('\n');
          
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              try {
                const data = JSON.parse(line.slice(6));
                if (data.error) {
                  onError(data.error);
                  return;
                }
                if (data.content) {
                  onChunk(data.content);
                }
                if (data.done && data.conversation_id) {
                  onDone(data.conversation_id);
                  return;
                }
              } catch (e) {
                console.error('Error parsing SSE data:', e);
              }
            }
          }
          
          return read();
        });
      }
      
      return read();
    }).catch(error => {
      onError(error.message);
    });
  },
  getConversations: () => api.get('/agent/conversations'),
  getConversation: (id) => api.get(`/agent/conversations/${id}`),
};

export default api;